<template lang="pug">
.full
  .dialog
    h1 Login
    form(@submit.prevent="login", v-if="!loading")
      input(placeholder="Password", ref="loginInput", type="password")
      button(type="submit") Login
    div(v-else)
      p Loading ...
    span.loginError(v-if="loginError && !loading") Invalid credentials
</template>

<script>
import ApiService from "../services/api";
import AuthService from "../services/auth";

export default {
  data: () => ({
    loading: false,
    loginError: false
  }),
  methods: {
    async login() {
      const token = this.$refs.loginInput.value;
      this.loginError = false;
      this.loading = true;
      const response = await ApiService.checkAuthToken(token);
      this.loading = false;
      if (!response) {
        this.loginError = true;
      } else {
        AuthService.setAuthToken(token);
        this.$router.push({ name: "home" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.full {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .dialog {
    padding: 20px;
    background: #fff;
    width: 300px;
    height: 120px;
    display: flex;
    flex-direction: column;

    h1 {
      margin-top: 0 !important;
    }

    .loginError {
      color: #f77;
      margin-top: 20px;
    }

    form {
      display: grid;
      grid-gap: 5px;
      grid-template-columns: 1fr auto;
    }
  }
}
</style>
